export default "__VITE_ASSET__2ac56665__"